import React, {Component} from 'react';
import moment from 'moment';

class TestTimer extends Component {
    constructor(props){
        super(props);

        this.state = {
            timerClass: '',
            userTime: 0,
            testTime: 0,
            lTimer: '',
            progressClass: '',
            progressText: '',
        }
        this.timer = null;
    }

    updateTimer = () => {
        if(!this.props.idle){
            if(this.state.testTime >= 0 || (this.props.mode !== "timed" && this.state.testTime < 0)){
                this.setState({userTime: this.state.userTime - 1, testTime: this.state.testTime - 1});
            }else if(this.props.mode === 'timed'){
                clearInterval(this.timer);
                this.props.stop();
            }
        }

    }

    componentDidMount(){
        if(!this.timer && this.props.start){
            this.timer = setInterval(this.updateTimer, 1000);
            this.setState({userTime: this.props.start, testTime: this.props.testTime});
        }
    }

    componentDidUpdate(){
        if(!this.timer && this.props.start){
            this.timer = setInterval(this.updateTimer, 1000);
            this.setState({userTime: this.props.start, testTime: this.props.testTime});
        }
    }

    render(){
        let {userTime, testTime} = this.state;
        let {totalQuestions, answeredQuestions} = this.props;
        let timer = null;
        let timerClass = '';
        let behind = 0;
        let ahead = 0;
        let lTimer = null;

        let seconds = parseInt(this.state.userTime % 60);
        timer = (seconds < 10) ? parseInt(this.state.userTime / 60) + ":" + "0" + seconds.toString()
            : parseInt(this.state.userTime / 60) + ":" + seconds.toString();

        if(this.state.testTime / this.props.testTime * 100 < 20){
            timerClass = 'text-warning';
        }else if(this.state.testTime / this.props.testTime * 100 < 10){
            timerClass = 'text-danger';
        }

        
        let progressTime = this.props.start - this.state.userTime;
        let timePerQuestion = this.props.start / totalQuestions;

        if(progressTime > (timePerQuestion * answeredQuestions) + timePerQuestion){
            behind = progressTime - (timePerQuestion * answeredQuestions) - timePerQuestion;
        }else if(progressTime < (timePerQuestion * answeredQuestions) + timePerQuestion){
            ahead = (timePerQuestion * answeredQuestions) - progressTime + timePerQuestion;
        }


        let progressText = '';
        let progressClass = 'text-success';

        let npt = timePerQuestion - progressTime;
        let npb = progressTime - timePerQuestion;


        if (behind && answeredQuestions > 0) {
            let minutes = Math.floor(behind / 60);
            npb = behind;
            if (minutes > 0) {
                let multiple = (minutes > 1);
                progressText = '(' + minutes.toString() + ` minute${multiple ? 's' : ''} behind)`;
                progressClass = 'text-danger';
            }
        } else if (ahead && answeredQuestions > 0) {
            let minutes = Math.floor(ahead / 60);
            npt = ahead;
            if (minutes > 0) {
                let multiple = (minutes > 1);
                progressText = '(' + minutes.toString() + ` minute${multiple ? 's' : ''} ahead)`;
                progressClass = 'text-success';
            }
        }

        if(this.props.show){
            return (
                <div className="col-sm-4 text-right" style={{paddingTop: '0px', display: this.props.show   ? 'block' : 'none'}}>

                        <div className="pull-right">
                            <div className="timer timer-head" style={(this.state.testTime && this.timer) ? {display: 'block'} : {}}>
                                <h1 className={`sm-top-bottom0 font-thin ${timerClass} font-30`}>{moment.utc(moment.duration(testTime * 1000).as('milliseconds')).format('HH:mm:ss')}</h1>
                                <h2 className={`${behind > 0 ? 'text-danger' : 'text-success'} no-margin timer2 font-14`}>{behind === 0 && npt > 0 ? 
                                '+' + moment.utc(moment.duration(npt * 1000).as('milliseconds')).format('HH:mm:ss')
                                : '-' + moment.utc(moment.duration(npb * 1000).as('milliseconds')).format('HH:mm:ss')}</h2>
                            </div>

                            {lTimer &&
                                <div className="timer timer-head" style={{display: 'block'}}>
                                    <h1 className={`sm-top-bottom0 font-thin text-danger font-30`}><i className="zmdi zmdi-lock" /> {lTimer}</h1>

                                </div>
                            }
                        </div>

                    </div>
            )
        }else if(this.props.mode === "training"){
            return (
                <div className="col-sm-4 text-right" style={{paddingTop: '0px'}}>

                        <div className="pull-right">
                            <div className="timer timer-head" style={(this.state.userTime && this.timer) ? {display: 'block'} : {}}>
                                <h1 className={`sm-top-bottom0 font-thin ${behind > 0 ? 'text-danger' : 'text-success'} font-30`}>{behind === 0 && npt > 0 ? 
                                '+' + moment.utc(moment.duration(npt * 1000).as('milliseconds')).format('HH:mm:ss')
                                : '-' + moment.utc(moment.duration(npb * 1000).as('milliseconds')).format('HH:mm:ss')}</h1>

                            </div>

                        </div>

                    </div>
            )
        }else{
            return (
                <div className="col-sm-4 text-right" style={{paddingTop: '0px', display: 'block'}}>
    
                        <div className="pull-right">
                            <div className="timer timer-head" style={(this.state.userTime && this.timer) ? {display: 'block'} : {}}>
                                <h1 className={`sm-top-bottom0 font-thin font-30`}>Untimed</h1>
                                <h2 className={`${progressClass} no-margin timer2 font-14`}></h2>
                            </div>
    
                            {lTimer &&
                                <div className="timer timer-head" style={{display: 'block'}}>
                                    <h1 className={`sm-top-bottom0 font-thin text-danger font-30`}><i className="zmdi zmdi-lock" /> {lTimer}</h1>
    
                                </div>
                            }
                        </div>
    
                    </div>
            )
        }
    }
}

export default TestTimer;


// WEBPACK FOOTER //
// ./src/components/UserCourse/TestTimer.js